module.exports = __webpack_public_path__ + "static/media/head.da2276da.png";